var _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationMentionLegals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 833.60436,
    height: 638.22869,
    viewBox: "0 0 833.60436 638.22869",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.71637,636.60466c0,.90073.72331,1.62403,1.62403,1.62403h809.63992c.90069,0,1.62403-.72331,1.62403-1.62403s-.72335-1.62403-1.62403-1.62403H22.3404c-.90072,0-1.62403.72331-1.62403,1.62403Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m440.55989,476.33668c-2.2231,13.47525-13.9493,23.78782-28.04423,23.78782s-25.82109-10.31257-28.04419-23.78782h-71.74861v155.49117h199.58563v-155.49113h-71.74863l.00004-.00004Z",
    fill: "#b6b3c5",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 316.204,
    y: 631.24777,
    width: 19.72649,
    height: 3.48113,
    fill: "#b6b3c5",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 490.84147,
    y: 631.82798,
    width: 19.72649,
    height: 3.48113,
    fill: "#b6b3c5",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m813.90439,480.39801H11.12674c-6.13535,0-11.12674-4.99167-11.12674-11.12675V11.12674C0,4.99168,4.99139,0,11.12674,0h802.77765c6.13537,0,11.127,4.99168,11.127,11.12674v458.14456c0,6.13508-4.99171,11.12675-11.127,11.12675v-.00004Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.30667,
    y: 19.72662,
    width: 785.57844,
    height: 443.26583,
    fill: "#fff",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150.90939,
    y: 134.38655,
    width: 207,
    height: 59,
    fill: "#c19a6b",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 146.88655,
    x2: 200.76646,
    y2: 146.88655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 163.88655,
    x2: 338.40939,
    y2: 163.88655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 388.60485,
    y1: 163.88655,
    x2: 430.05884,
    y2: 163.88655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 177.74146,
    x2: 243.03994,
    y2: 177.74146,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 263.88655,
    x2: 278.90939,
    y2: 263.88655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 280.88655,
    x2: 261.90939,
    y2: 280.88655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 294.74146,
    x2: 243.03994,
    y2: 294.74146,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 206.58976,
    x2: 270.19129,
    y2: 206.58976,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 221.01392,
    x2: 338.40939,
    y2: 221.01392,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 169.40939,
    y1: 237.13503,
    x2: 243.03994,
    y2: 237.13503,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 365.40939,
    y1: 80.88655,
    x2: 365.40939,
    y2: 371.88655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 388.60485,
    y1: 196.38655,
    x2: 675.79127,
    y2: 196.38655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 388.60485,
    y1: 214.41454,
    x2: 556.40939,
    y2: 214.41454,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 388.60485,
    y1: 229.38655,
    x2: 581.04165,
    y2: 229.38655,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 388.60485,
    y1: 245.99774,
    x2: 736.40939,
    y2: 245.99774,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMentionLegals);
export default __webpack_public_path__ + "static/media/illustration-mention-legals.2ad223b3a5803d438588f8a3f132fc07.svg";
export { ForwardRef as ReactComponent };